import { render, staticRenderFns } from "./TraderForm.vue?vue&type=template&id=0594331f&"
import script from "./TraderForm.vue?vue&type=script&lang=js&"
export * from "./TraderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports